export default __webpack_public_path__ + "static/bmw-2-c8314bb1dfcb27d564766356be50baad.jpg";